import { IconBriefcase, IconBuilding } from '@tabler/icons-react';
import { WelcomeExtensions } from '@ayocore/platform/client/components/Welcome/WelcomeExtensions';
import { SalesPlanWelcomeBlock } from '../components/Welcome/SalesPlanWelcomeBlock';
import { UserDealsWelcomeBlock } from '../components/Welcome/UserDealsWelcomeBlock';
import { BranchDealsWelcomeBlock } from '../components/Welcome/BranchDealsWelcomeBlock';

/**
 * Регистрация CRM-карточек и блоков статистики на WelcomePage.
 * Вызывается из CRM bootstrap.ts.
 */
export function registerCrmWelcomeExtensions(): void {
  // Навигационные карточки
  WelcomeExtensions.navigationCards.register(() => ({
    key: 'crm-deals',
    label: 'Сделки',
    icon: IconBriefcase,
    url: '/crm/deals',
    order: 10,
  }));
  WelcomeExtensions.navigationCards.register(() => ({
    key: 'crm-partners',
    label: 'Партнеры',
    icon: IconBuilding,
    url: '/crm/partners',
    order: 20,
  }));

  // Блоки статистики
  WelcomeExtensions.statBlocks.register(() => ({
    key: 'crm-sales-plan',
    label: 'План продаж',
    content: <SalesPlanWelcomeBlock />,
    order: 10,
  }));
  WelcomeExtensions.statBlocks.register(() => ({
    key: 'crm-user-deals',
    label: 'Твои сделки',
    content: <UserDealsWelcomeBlock />,
    order: 20,
  }));
  WelcomeExtensions.statBlocks.register(() => ({
    key: 'crm-branch-deals',
    label: 'Сделки филиала',
    content: <BranchDealsWelcomeBlock />,
    order: 30,
  }));
}
